export default "__VITE_ASSET__BR_wtIUV__"